export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "bugbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
